import './App.css';
import './lib/semantic/semantic.css';
import './scss/styles.scss';

import { Route, Routes, HashRouter } from 'react-router-dom';
import SDF from "./pages/SDF";

const App = () => {
  return (
    <>
      <HashRouter>
       <Routes>
         <Route path='/' element={<SDF/>} />
         <Route path='/sdf' element={<SDF/>} />
       </Routes>
       </HashRouter>
    </>
  );
}

export default App;
